import { render, staticRenderFns } from "./ClientAddnew.vue?vue&type=template&id=bed7ac28&"
import script from "./ClientAddnew.vue?vue&type=script&lang=js&"
export * from "./ClientAddnew.vue?vue&type=script&lang=js&"
import style0 from "./ClientAddnew.vue?vue&type=style&index=0&id=bed7ac28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports